const unwrapLinksHtml = (html:string) => {
  const root = document.createElement('div');
  root.innerHTML = html;

  [...root.querySelectorAll('a')].forEach((anchor) => {
    const parent = anchor.parentNode;
    if (!parent) return;

    while (anchor.firstChild) {
      parent.insertBefore(anchor.firstChild, anchor);
    }
    parent.removeChild(anchor);
  });

  return root.innerHTML;
};

export default unwrapLinksHtml;
